module.exports = __webpack_public_path__ + "media/images/form-c58e9d84ca4f456f9c697e2c1eefab0d.png";